import { NATIVE_USDC_HELP_TEXT } from '@/hooks/useCustomContent';

import { ChildRowIssuerBadge } from './ChildRowIssuerBadge';

/**
 * A compact version of IssuedByCircleBadge specifically for child rows in the discovery table.
 * Shows "by Circle" on mobile (<467px) and "Issued by Circle" on larger screens.
 * Maintains consistent styling with the standard Badge component but with responsive behavior.
 */
export function ChildRowCircleBadge() {
  return <ChildRowIssuerBadge issuerName="Circle" tooltipContent={NATIVE_USDC_HELP_TEXT} />;
}
